function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var dataProps = function dataProps(props) {
  return Object.keys(props).filter(function (propName) {
    var value = props[propName]; // don't include non-data attributes

    if (!propName.startsWith('data-')) {
      return false;
    } // don't include data attributes with boolean or null-ish values
    // (similar to React ignoring those as children)


    if (value === true || value === false || value === undefined || value === null) {
      return false;
    } // throw for invalid data attribute name


    if (typeof document !== 'undefined') {
      var el = document.createElement('div');
      el.setAttribute(propName, '');
    } // include data attributes with string or number values


    if (typeof value === 'string' || typeof value === 'number') {
      return true;
    } // throw for all other data attribute values


    throw new Error("Data attribute ".concat(propName, " has nonsensical value ").concat(value));
  }).reduce(function (acc, propName) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, propName, props[propName]));
  }, {});
};

export default dataProps;